import templateUrl from '../transportation-providers-template.html';
import assignIn from 'lodash/assignIn';
import size from 'lodash/size';

export const transportationProvidersMainComponent = {
	templateUrl,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		serviceArea: '<',
		serviceType: '<',
		paymentMethods: '<',
		onSubmit: '&',
		onPrevious: '&',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for TransportationProvidersMainComponent
	controller: class TransportationProvidersMainComponent {
		constructor($state, ModalService, toastr) {
			'ngInject';

			this.$state = $state;
			this.modalService = ModalService;
			this.toastr = toastr;
		}

		$onInit() {
			this.step = 1;
			this.isBasicInfoActive = true;
			this.isServiceInfoActive = false;
			this.isOperationInfoClassInActive = false;
			this.isOtherInfoClassActive = false;
			this.isServiceInfoSubmitted = false;
			this.isOperationInfoClassSubmitted = false;
			this.isOtherInfoClassSubmitted = false;
			this.details = this.details || {
				basicInfo: {
					phone: [],
					name: "",
					url: "",
					image: "",
					email: ""
				},
				serviceInfo: {
					serviceType: [],
					serviceArea: [],
					specialRequirements: [],
					medicaidSupport: true,
					veteranSupport: true
				},
				operationInfo: {
					daysOfOperation: "",
					hoursOfOperation: {}
				},
				otherInfo: {
					fees: "",
					methodOfPayment: [],
					notes: ""
				}
			};
			this.saveData = angular.copy(this.details);
		}

		onSubmitBasicInfo(details) {
			this.isServiceInfoActive = true;
			this.isBasicInfoActive = false;
			this.step += 1;
			this.details = assignIn(this.details, details);
			document.querySelector(".rightpanel").scrollTop = 0;
		}

		onSubmitServiceInfo(details) {
			if (size(details.serviceInfo.serviceType) > 0 && size(details.serviceInfo.serviceArea) > 0) {
				this.isServiceInfoSubmitted = true;
				this.isOperationInfoClassActive = true;
				this.step += 1;
				this.details = assignIn(this.details, details);
				document.querySelector(".rightpanel").scrollTop = 0;
			} else {
				this.toastr.error("Please select service type and service area");
			}
		}

		onSubmitOperationInfo(details) {
			this.isOperationInfoClassSubmitted = true;
			this.isOtherInfoClassActive = true;
			this.step += 1;
			this.details = assignIn(this.details, details);
			document.querySelector(".rightpanel").scrollTop = 0;
		}

		onSubmitOtherInfo(details) {
			if(size(details.otherInfo.methodOfPayment) > 0) {
				this.isOtherInfoClassSubmitted = true;
				this.details = assignIn(this.details, details);
				this.onSubmit({
					$event: this.details
				});
			} else {
				this.toastr.error("Please select Payment methods");
			}
		}

		onServiceInfoPrevious(details) {
			this.isServiceInfoActive = false;
			this.isBasicInfoActive = true;
			this.step -= 1;
			this.details = assignIn(this.details, details);
			document.querySelector(".rightpanel").scrollTop = 0;
		}

		onOperationInfoPrevious(details) {
			this.isServiceInfoSubmitted = false;
			this.isOperationInfoClassActive = false;
			this.step -= 1;
			this.details = assignIn(this.details, details);
			document.querySelector(".rightpanel").scrollTop = 0;
		}

		onOtherInfoPrevious(details) {
			this.isOperationInfoClassSubmitted = false;
			this.isOtherInfoClassActive = false;
			this.step -= 1;
			this.details = assignIn(this.details, details);
			document.querySelector(".rightpanel").scrollTop = 0;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/transportation-providers/transportation-providers-main/transportation-providers-main.component.js